import { render } from "./posSwitchConfirm.vue?vue&type=template&id=0155c50a&scoped=true&lang=html"
import script from "./posSwitchConfirm.vue?vue&type=script&lang=js"
export * from "./posSwitchConfirm.vue?vue&type=script&lang=js"

import "./posSwitchConfirm.vue?vue&type=style&index=0&id=0155c50a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0155c50a"]])

export default __exports__